const { setInitialised, useDots } = window.BAO.Carousel.plugins

class QuoteCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 901px)': {
            slides: {
              perView: 1,
              spacing: 0,
            },
          },
          '(min-width: 1201px)': {
            slides: {
              perView: 1,
              spacing: 0,
            },
          },
        },
      },
      [setInitialised(), useDots(this.els?.dot?.elements)],
    )
  }
}

if (!customElements.get('quote-carousel')) {
  customElements.define('quote-carousel', QuoteCarousel)
}
